import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

const fullImplementationLink = KbArticleUrls.adminImplementation;

const implementationTimelines = {
  short: {
    '0-50 users': '5 days',
    '50-500 users': '10 days',
    '>500 users': '15+ days',
  },
  long: {
    '0-50 users': '10 days',
    '50-500 users': '20 days',
    '>500 users': '1 month',
  },
};

const implementationPhases = {
  appIntegration: {
    name: 'Configure App Integration',
    steps: [
      'Configure SAML app integration',
      'Configure JIT app integration',
      'Configure SCIM app integration',
      'Bind user groups to SSO applications',
    ],
  },
  auth: {
    name: 'Configure Auth',
    steps: [
      'Configure LDAP & create LDAP groups',
      'Point wifi or VPN to RADIUS endpoint and connect to user groups',
    ],
  },
  conditionalAccessPolicies: {
    name: 'Conditional Access Policies',
    steps: [
      'Configure conditional access policies',
      'Configure device trust policies',
      'Configure network trust policies',
      'Configure geo-location policies',
    ],
  },
  devices: {
    name: 'Set Up Devices',
    steps: [
      'Install JumpCloud agent on devices',
      'Assign users to their devices',
      'Enroll devices in MDM using Mac MDM policy',
      'Create device groups to align with org security policies, departments, or location and asign devices to groups',
      'Configure MFA for devices',
      'Configure device configurations/policies for Mac, Windows, & Linux',
    ],
  },
  userImport: {
    name: 'Import and Bind Users to Jumpcloud Directory',
    steps: [
      'Create a new directory in JumpCloud',
      'Import users from your cloud directory',
      'Bind new users to JC directory',
      'Create user groups',
      'Enroll users in MFA',
    ],
  },
  userSecuritySettings: {
    name: 'Configure User Security Settings',
    steps: [
      'Configure global password requirements',
      'Configure global MFA options',
      'Invite aditional admin to JumpCloud',
    ],
  },
};

const ImplementationGuides = [{
  name: 'SSO Package',
  phases: [
    implementationPhases.userSecuritySettings,
    implementationPhases.userImport,
    implementationPhases.appIntegration,
  ],
  shortTimeline: true,
}, {
  name: 'Core Directory Package',
  phases: [
    implementationPhases.userSecuritySettings,
    implementationPhases.userImport,
    implementationPhases.appIntegration,
    implementationPhases.auth,
  ],
  shortTimeline: true,
}, {
  name: 'JumpCloud Platform Package',
  phases: [
    implementationPhases.userSecuritySettings,
    implementationPhases.userImport,
    implementationPhases.devices,
    implementationPhases.appIntegration,
    implementationPhases.auth,
  ],
  shortTimeline: false,
}, {
  name: 'PlatformPlus Package',
  phases: [
    implementationPhases.userSecuritySettings,
    implementationPhases.userImport,
    implementationPhases.devices,
    implementationPhases.appIntegration,
    implementationPhases.auth,
    implementationPhases.conditionalAccessPolicies,
  ],
  shortTimeline: false,
}];

export default {
  ImplementationGuides,
  fullImplementationLink,
  implementationTimelines,
};
